import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { laboratoryService, productService } from 'shared/services';
import { Option, OptionDescription } from 'shared/types/general';
import { IOperationalUnit } from '../types';

interface FormParams {
  operational_unit: IOperationalUnit;
  onSubmit: any;
  disableEdit?: boolean;
}
function OperationalUnitForm(params: FormParams) {
  const { t } = useTranslation();

  const [laboratories, setLaboratories] = useState<Option[]>([]);
  const [products, setProducts] = useState<OptionDescription[]>([]);

  useEffect(() => {
    laboratoryService.getAllBaseInformation().then(setLaboratories);
    productService.getAllBaseInformation().then(setProducts);
  }, []);

  const { operational_unit, onSubmit, disableEdit } = params;
  return (
    <div>
      {operational_unit && (
        <>
          <EnhancedForm
            onSubmit={disableEdit ? {} : onSubmit}
            disableEdit={disableEdit}
            edit={!!operational_unit.id}>
            <div className="flex flex-wrap">
              <div className="w-full my-4">
                <IdentityField
                  name="code"
                  initialValue={operational_unit.code}
                  component={TextFieldAdapter}
                  label={t('global.code')}
                  type="text"
                  validate={required}
                  disabled={disableEdit}
                />
              </div>
              <div className="w-full md:w-2/3">
                <IdentityField
                  name="description"
                  initialValue={operational_unit.description}
                  component={TextFieldAdapter}
                  label={t('global.description')}
                  type="text"
                  validate={required}
                  disabled={disableEdit}
                />
              </div>

              <div className="w-full my-4">
                {laboratories && (
                  <IdentityField
                    name="laboratory"
                    component={AutocompleteAdapter}
                    initValue={laboratories.find((s) => s.id === operational_unit.laboratory)}
                    defaultValue={operational_unit.laboratory}
                    options={laboratories}
                    label={t('global.laboratory')}
                    type="text"
                    disabled={disableEdit}
                  />
                )}
              </div>
            </div>
          </EnhancedForm>
        </>
      )}
    </div>
  );
}

export default OperationalUnitForm;
